import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { TelegramNotifyQueryKeys } from '../../../keys'
import { getTelegramNotifySetting } from '../../services'

import type { TelegramNotifySettingResponse } from '../../../types'

export default function useQueryGetTelegramNotifySetting(
	props?: UseBaseQueryOptions<TelegramNotifySettingResponse>,
) {
	return useQuery({
		queryKey: [TelegramNotifyQueryKeys.GetTelegramNotifySetting],
		queryFn: () => getTelegramNotifySetting(),
		...props,
	})
}
